import PropTypes from "prop-types";
import {createContext, useCallback, useEffect, useReducer} from "react";
import {initializeApp} from "firebase/app";
import {getAuth, onAuthStateChanged, signInWithEmailAndPassword, signOut} from "firebase/auth";
import {getFirestore} from "firebase/firestore";
import {getDatabase, ref} from "firebase/database";
import {getStorage, ref as sRef} from "firebase/storage";

import {FIREBASE_API} from "../config";
import {clearSession} from "../helper/session";

// ----------------------------------------------------------------------

const initialState = {
  isInitialized: false,
  isAuthenticated: false,
  user: null,
};

const ACTION_TYPES = {
  INITIAL: "INITIAL",
};

const reducer = (state, action) => {
  if (action.type === ACTION_TYPES.INITIAL) {
    return {
      isInitialized: true,
      isAuthenticated: action.payload.isAuthenticated,
      user: action.payload.user,
    };
  }

  return state;
};

// ----------------------------------------------------------------------

export const AuthContext = createContext(null);

// ----------------------------------------------------------------------

const firebaseApp = initializeApp(FIREBASE_API);

export const AUTH = getAuth(firebaseApp);
export const DB = getFirestore(firebaseApp);
export const RDB = getDatabase(firebaseApp);
export const dbRef = ref(RDB);
export const storageRef = getStorage(firebaseApp);
export const usersImageStorage = sRef(storageRef, "public/userphotos");

AuthProvider.propTypes = {
  children: PropTypes.node,
};

export function AuthProvider({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);

  const initialize = useCallback(() => {
    try {
      onAuthStateChanged(AUTH, (user) => {
        if (user) {
          // const userRef = doc(DB, "users", user.uid);
          // const docSnap = await getDoc(userRef);
          // const profile = docSnap.data();
          // await getUserInfo(user);

          dispatch({
            type: ACTION_TYPES.INITIAL,
            payload: {
              isAuthenticated: true,
              user: {
                ...user,
                // ...profile,
                // role: "admin",
              },
            },
          });
        } else {
          dispatch({
            type: ACTION_TYPES.INITIAL,
            payload: {
              isAuthenticated: false,
              user: null,
            },
          });
        }
      });
    } catch (error) {
      console.error(error);
    }
  }, []);

  useEffect(() => {
    initialize();
    return () => initialize();
    // eslint-disable-next-line
  }, []);

  // LOGIN
  const login = (email, password) => signInWithEmailAndPassword(AUTH, email, password);

  // LOGOUT
  const logout = async () => {
    clearSession(true);
    await signOut(AUTH);
    dispatch({
      type: ACTION_TYPES.INITIAL,
      payload: {
        isAuthenticated: false,
        user: null,
      },
    });
  };

  return (
      <AuthContext.Provider
          value={{
            ...state,
            method: "firebase",
            login,
            logout,
          }}
      >
        {children}
      </AuthContext.Provider>
  );
}
